
import ContentFooter from '@/components/ContentFooter.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	components: {
		AppLayout,
		ContentFooter,
	}
})

export default class TermAndCondition extends Vue {

}
